var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.458 2.942 1.214 2.56c.236.499.693.845 1.222.924l2.714.411c1.332.201 1.864 1.905.899 2.883l-1.965 1.993a1.733 1.733 0 0 0-.467 1.496l.464 2.813c.226 1.379-1.164 2.432-2.355 1.781l-2.429-1.328a1.568 1.568 0 0 0-1.512 0l-2.429 1.328c-1.191.651-2.584-.401-2.355-1.781l.464-2.813a1.738 1.738 0 0 0-.467-1.496L2.491 9.72c-.964-.978-.433-2.682.899-2.883l2.714-.411a1.623 1.623 0 0 0 1.222-.924l1.213-2.56a1.595 1.595 0 0 1 2.911 0h.005Z"
  })));
};
export default SvgStar;